import "./narrativeLabelList.scss";

import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { findDOMNode } from "react-dom";

import Dimensions from "../../constants/styles/dimensions";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import { withContainerContext } from "../container/ContainerContext";

class NarrativeLabelHeaderRow extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      disableDrag: false
    };
  }

  componentDidMount() {
    this._domNode = findDOMNode(this);
  }

  render() {
    const isIos = preprocessorQuery.isIos();

    let width = Dimensions.MODAL_SETTINGS_LIST_OPTIONS_WIDTH;

    if (isIos || this.props.useContainerWidth) {
      width = null;
    }

    const style = {
      width: !_.isNil(width) ? `${width}px` : null
    };

    return (
      <React.Fragment>
        <div className={`narrativeLabelRow narrativeLabelHeaderRow doubleSpan`} style={style}>
          <div className="narrativeLabelField">
            <span>&nbsp;</span>
          </div>
          <div className="narrativeLabelField">
            <span>&nbsp;</span>
          </div>
          <div className="narrativeLabelField">
            <span>Can auto assign to:</span>
          </div>
          <div className="narrativeLabelField">
            <span>&nbsp;</span>
          </div>
        </div>
        <div className={`narrativeLabelRow narrativeLabelHeaderRow`} style={style}>
          <div className="narrativeLabelField">
            <span>&nbsp;</span>
          </div>
          <div className="narrativeLabelField">
            <span>Section Label</span>
          </div>
          <div className="narrativeLabelField">
            <span>Folders</span>
          </div>
          <div className="narrativeLabelField">
            <span>Other Types</span>
          </div>
          <div className="narrativeLabelField">
            <span>&nbsp;</span>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

NarrativeLabelHeaderRow.propTypes = {
  useContainerWidth: PropTypes.bool,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired,
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number
};

export default withContainerContext(NarrativeLabelHeaderRow);
